import Box from '@mui/material/Box'
import type { SxProps, Theme } from '@mui/material/styles'

import { Text } from '@mxenabled/mxui'

import { formatCurrency } from '../../core/utils/NumberFormatting'

import { getLogoElevation } from './logoShadow'

interface SaveAnExtraCardProps {
  primaryText?: string[]
  secondaryText?: string[]
  bgcolor?: string
  sx?: SxProps<Theme>
}

const SaveAnExtraCard = ({
  primaryText = [],
  secondaryText = [],
  bgcolor = 'success.main',
  sx,
}: SaveAnExtraCardProps) => {
  const [leadIn, amount, trailingCopy] = primaryText
  const [projected, projectedCaption] = secondaryText

  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'success.main',
        borderRadius: 2,
        boxShadow: getLogoElevation,
        overflow: 'hidden',
        ...sx,
      }}
    >
      {/* Green header */}
      <Box
        sx={{
          bgcolor,
          color: 'success.contrastText',
          p: 16,
          pt: 12,
          textAlign: 'center',
        }}
      >
        <Text color="inherit" variant="subtitle1">
          {leadIn}
        </Text>
        <Text bold={true} color="inherit" variant="h1">
          {formatCurrency(Number(amount ?? '0'), '0,0.00')}
        </Text>
        <Text color="inherit" variant="caption">
          {trailingCopy}
        </Text>
      </Box>

      {/* White footer with projected amount. The projected balance arrives
          pre-formatted from the backend (e.g. "$3,320"), so render it as-is. */}
      <Box sx={{ bgcolor: 'background.paper', px: 16, py: 12, textAlign: 'center' }}>
        <Text variant="h3">{projected}</Text>
        <Text color="text.secondary" variant="caption">
          {projectedCaption}
        </Text>
      </Box>
    </Box>
  )
}

export default SaveAnExtraCard
